import { ForecastObsInfo } from "libs/types";
import styled from "styled-components";
import LastUpdated from "./LastUpdated";
import SatImage from "./SatImage";
import Forecast from "./Forecast";
import SatIframe from "./SatIframe";

const Container = styled.section`
  padding: 60px 0px;
  margin: 0 auto;
  max-width: 1460px;

  &:not(:last-child) {
    border-bottom: 2px solid #c0c0c0;
  }
`;

const SatImageView = styled.div`
  width: 46%;
`;

const SatImageContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const ForecastView = styled.div`
  width: 64%;
`;

const Layout = styled.div`
  display: flex;
  gap: 40px;
  
  @media screen and (max-width: 1280px) {
    flex-direction: column;
    align-items: center;

    ${SatImageView}, ${ForecastView} {
      width: 100%;
    }
  }
`;

const Country = styled.span`
  display: block;
  margin-bottom: 6px;
  font-size: 24px;
  font-weight: 700;
`;

const ForecastTitle = styled.span`
  display: block;
  margin-bottom: 6px;
  font-size: 20px;
  font-weight: 700;
`;

interface ObsInfoProps extends ForecastObsInfo {
  isIframe?: boolean;
}

const ObsInfo = ({isIframe, ...obsInfo}: ObsInfoProps) => {
  return <Container>
    <Country>{obsInfo.country}</Country>
    <Layout>
      <SatImageView>
        <LastUpdated id={obsInfo.id} updatedAt={obsInfo.sat_image.obs_updated_at} type="image" />
        <SatImageContainer>
          {isIframe ? <SatIframe id={obsInfo.id} /> : (
            <SatImage id={obsInfo.id} url={obsInfo.sat_image.url} type={obsInfo.sat_image.type}  />
          )}
        </SatImageContainer>
      </SatImageView>
      <ForecastView>
        <ForecastTitle>Hourly Forecast</ForecastTitle>
        <LastUpdated id={obsInfo.id} updatedAt={obsInfo.forecast.obs_updated_at} type="info" />
        <Forecast data={obsInfo.forecast} />
      </ForecastView>
    </Layout>
  </Container>
}

export default ObsInfo;